const Cardano = () => (
    <svg
        width='116'
        height='116'
        viewBox='0 0 116 116'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle cx='57.5503' cy='57.574' r='57.5' fill='white' />
        <path
            d='M40.3898 57.3065C40.2191 60.2727 42.5025 62.8122 45.4688 62.9829C45.5755 62.9829 45.6822 62.9829 45.7889 62.9829C48.7765 62.9829 51.1879 60.5715 51.1665 57.5839C51.1665 54.5963 48.7551 52.1849 45.7675 52.2062C42.908 52.2062 40.5392 54.4469 40.3898 57.3065Z'
            fill='#0033AD'
        />
        <path
            d='M20.287 55.9192C19.3267 55.8552 18.4944 56.6021 18.4517 57.5624C18.4091 58.5227 19.1346 59.355 20.0949 59.3977C21.0552 59.4617 21.8661 58.7148 21.9302 57.7545C21.9942 56.7942 21.2473 55.9833 20.287 55.9192Z'
            fill='#0033AD'
        />
        <path
            d='M40.048 26.0217C40.9016 25.5949 41.243 24.5279 40.8162 23.6743C40.3894 22.8207 39.3224 22.4792 38.4688 22.906C37.6152 23.3328 37.2738 24.3785 37.7006 25.2321C38.1274 26.107 39.173 26.4698 40.048 26.0217C40.048 26.0217 40.0266 26.0217 40.048 26.0217Z'
            fill='#0033AD'
        />
        <path
            d='M45.5107 35.5611C46.8338 34.8996 47.3673 33.2778 46.7058 31.9547C46.0442 30.6316 44.4224 30.0981 43.0993 30.7596C41.7762 31.4212 41.2427 33.043 41.9043 34.3661C42.5658 35.6892 44.1877 36.2227 45.5107 35.5611Z'
            fill='#0033AD'
        />
        <path
            d='M27.116 42.1127C28.1403 42.7743 29.5061 42.4969 30.1889 41.4725C30.8505 40.4482 30.5731 39.0825 29.5487 38.3996C28.5244 37.738 27.1587 38.0155 26.4758 39.0398C25.7929 40.0641 26.0917 41.4512 27.116 42.1127Z'
            fill='#0033AD'
        />
        <path
            d='M30.3808 54.9589C28.887 54.8735 27.628 56.0045 27.5426 57.4983C27.4573 58.9921 28.5883 60.2512 30.0821 60.3366C31.5759 60.4219 32.8349 59.2909 32.9203 57.7971C33.0057 56.3246 31.8746 55.0442 30.3808 54.9589Z'
            fill='#0033AD'
        />
        <path
            d='M27.415 73.0343C26.3266 73.5891 25.8785 74.9122 26.4333 76.0219C26.9882 77.1102 28.3113 77.5584 29.4209 77.0035C30.5093 76.4487 30.9574 75.1256 30.4026 74.0159C29.8477 72.9276 28.5033 72.4795 27.415 73.0343Z'
            fill='#0033AD'
        />
        <path
            d='M37.8712 49.3895C39.3436 50.3498 41.3069 49.9444 42.2459 48.4719C43.2062 46.9995 42.8007 45.0362 41.3283 44.0972C39.8558 43.1369 37.8925 43.5424 36.9536 45.0148C35.9933 46.466 36.3987 48.4292 37.8712 49.3895Z'
            fill='#0033AD'
        />
        <path
            d='M71.0551 35.348C72.2929 36.1589 73.9787 35.8175 74.7896 34.5797C75.6006 33.342 75.2591 31.6562 74.0214 30.8452C72.7837 30.0343 71.0978 30.3758 70.2869 31.6135C69.4546 32.8725 69.7961 34.5371 71.0551 35.348Z'
            fill='#0033AD'
        />
        <path
            d='M76.5606 25.8521C77.3715 26.3856 78.4385 26.1508 78.972 25.3399C79.5055 24.529 79.2708 23.462 78.4599 22.9285C77.6489 22.395 76.5819 22.6297 76.0484 23.4193C75.5363 24.2302 75.771 25.3186 76.5606 25.8521Z'
            fill='#0033AD'
        />
        <path
            d='M71.4611 52.1639C68.4948 51.9932 65.934 54.2766 65.7846 57.2428C65.6139 60.2091 67.8973 62.7699 70.8635 62.9193C70.9702 62.9193 71.0769 62.9193 71.1623 62.9193C74.1286 62.9193 76.54 60.5078 76.54 57.5202C76.5613 54.682 74.3206 52.3133 71.4611 52.1639Z'
            fill='#0033AD'
        />
        <path
            d='M47.282 49.0045C48.1996 50.8184 50.0562 51.9708 52.1049 51.9708C55.0711 51.9708 57.4825 49.5594 57.4825 46.5718C57.4825 45.7395 57.2905 44.9073 56.9064 44.139C55.5619 41.4715 52.3183 40.4045 49.6721 41.7489C47.0046 43.1147 45.9376 46.3584 47.282 49.0045Z'
            fill='#0033AD'
        />
        <path
            d='M89.5142 42.1128C90.6026 41.5579 91.0294 40.2135 90.4745 39.1252C89.9197 38.0368 88.5753 37.61 87.4869 38.1649C86.3986 38.7197 85.9718 40.0428 86.5053 41.1311C87.0815 42.2195 88.4045 42.6676 89.5142 42.1128Z'
            fill='#0033AD'
        />
        <path
            d='M75.8565 43.8199C74.2987 44.6095 73.6585 46.5088 74.4481 48.0666C75.2377 49.6244 77.1369 50.2646 78.6947 49.475C80.2526 48.6855 80.8928 46.7862 80.1032 45.2284C79.3136 43.6706 77.4143 43.0517 75.8565 43.8199Z'
            fill='#0033AD'
        />
        <path
            d='M58.2507 25.0408C59.467 25.1048 60.5127 24.1658 60.5981 22.9494C60.6834 21.7331 59.7231 20.6874 58.5067 20.602C57.2904 20.538 56.2447 21.4556 56.1593 22.672C56.0953 23.9097 57.0343 24.9554 58.2507 25.0408Z'
            fill='#0033AD'
        />
        <path
            d='M58.23 38.9758C59.9799 39.0825 61.4737 37.7381 61.5591 35.9882C61.6658 34.2383 60.3214 32.7445 58.5715 32.6591C56.8216 32.5524 55.3278 33.8969 55.2424 35.6467C55.1571 37.3966 56.4802 38.8904 58.23 38.9758Z'
            fill='#0033AD'
        />
        <path
            d='M41.0727 71.3272C42.6305 70.5376 43.2707 68.6383 42.4811 67.0805C41.6915 65.5227 39.7923 64.8825 38.2344 65.6721C36.6766 66.4617 36.0364 68.3609 36.826 69.9187C37.6156 71.4766 39.5148 72.1168 41.0727 71.3272Z'
            fill='#0033AD'
        />
        <path
            d='M60.2778 43.6066C58.656 46.1034 59.3389 49.4324 61.8356 51.0542C64.3324 52.6761 67.6615 51.9932 69.2833 49.4964C70.9051 46.9996 70.2223 43.6706 67.7255 42.0488C66.8505 41.4726 65.8262 41.1738 64.7806 41.1738C62.9667 41.1738 61.2808 42.0914 60.2778 43.6066Z'
            fill='#0033AD'
        />
        <path
            d='M69.6466 66.1416C68.3022 63.4741 65.0585 62.4071 62.4123 63.7515C59.7448 65.0959 58.6778 68.3396 60.0223 70.9858C61.3667 73.6533 64.6104 74.7203 67.2565 73.3758C69.9027 72.0528 70.991 68.8518 69.6679 66.1843C69.6679 66.1629 69.6679 66.1629 69.6466 66.1416Z'
            fill='#0033AD'
        />
        <path
            d='M79.0577 65.7575C77.5853 64.7972 75.622 65.2027 74.683 66.6751C73.7227 68.1476 74.1282 70.1109 75.6007 71.0498C77.0731 72.0101 79.0364 71.6047 79.9754 70.1322C80.9357 68.6811 80.5302 66.7178 79.0577 65.7575Z'
            fill='#0033AD'
        />
        <path
            d='M89.3862 57.6692C89.4716 56.1754 88.3406 54.9163 86.8468 54.8309C85.353 54.7456 84.0939 55.8766 84.0086 57.3704C83.9232 58.8642 85.0542 60.1233 86.548 60.2086C88.0205 60.294 89.3009 59.1416 89.3862 57.6692Z'
            fill='#0033AD'
        />
        <path
            d='M96.8335 55.7492C95.8732 55.6852 95.0409 56.4321 94.9982 57.3924C94.9556 58.3527 95.6811 59.1849 96.6414 59.2276C97.6017 59.2916 98.4126 58.5447 98.4767 57.5844C98.5193 56.6241 97.7938 55.8132 96.8335 55.7492Z'
            fill='#0033AD'
        />
        <path
            d='M89.8123 73.0342C88.7879 72.3727 87.4222 72.6501 86.7393 73.6744C86.0778 74.6988 86.3552 76.0645 87.3795 76.7474C88.4038 77.4089 89.7696 77.1315 90.4525 76.1072C91.1353 75.0829 90.8366 73.6958 89.8123 73.0342Z'
            fill='#0033AD'
        />
        <path
            d='M40.3471 89.2951C39.5362 88.7616 38.4692 88.9963 37.9357 89.7859C37.4022 90.5968 37.6369 91.6638 38.4265 92.1973C39.2374 92.7308 40.3044 92.4961 40.8379 91.7065C41.3928 90.9169 41.158 89.8286 40.3471 89.2951Z'
            fill='#0033AD'
        />
        <path
            d='M76.8809 89.1245C76.0273 89.5513 75.6859 90.6183 76.1127 91.4719C76.5395 92.3255 77.6065 92.6669 78.4601 92.2401C79.3137 91.8133 79.6551 90.7676 79.2283 89.914C78.8015 89.0391 77.7559 88.6763 76.8809 89.1245C76.8809 89.1245 76.9023 89.1245 76.8809 89.1245Z'
            fill='#0033AD'
        />
        <path
            d='M56.6505 71.5403C58.2723 69.0435 57.5894 65.7145 55.0927 64.0713C52.5959 62.4494 49.2668 63.1323 47.6237 65.6291C45.9805 68.1259 46.6847 71.4549 49.1815 73.0981C50.0564 73.6743 51.0807 73.973 52.1264 73.973C53.9616 73.9944 55.6475 73.0768 56.6505 71.5403Z'
            fill='#0033AD'
        />
        <path
            d='M45.8741 79.7995C44.6363 78.9885 42.9505 79.33 42.1396 80.5677C41.3286 81.8054 41.6701 83.4913 42.9078 84.3022C44.1455 85.1131 45.8314 84.7717 46.6423 83.534C47.4746 82.2962 47.1331 80.6104 45.8741 79.7995Z'
            fill='#0033AD'
        />
        <path
            d='M58.4431 90.1061C57.2268 90.0421 56.1811 90.9811 56.0957 92.1974C56.0104 93.4138 56.9707 94.4595 58.1871 94.5448C59.4034 94.6089 60.4491 93.6912 60.5345 92.4749C60.5985 91.2371 59.6595 90.1915 58.4431 90.1061Z'
            fill='#0033AD'
        />
        <path
            d='M58.4644 76.1707C56.7145 76.064 55.2207 77.4085 55.1353 79.1583C55.0286 80.9082 56.3731 82.402 58.1229 82.4874C59.8728 82.5727 61.3666 81.2497 61.452 79.4998C61.5587 77.7712 60.2143 76.2561 58.4644 76.1707Z'
            fill='#0033AD'
        />
        <path
            d='M71.418 79.586C70.0949 80.2689 69.5614 81.8907 70.2443 83.2138C70.9272 84.5369 72.549 85.0704 73.8721 84.3875C75.1952 83.726 75.7287 82.1041 75.0671 80.7811C74.3842 79.458 72.7624 78.9031 71.418 79.586Z'
            fill='#0033AD'
        />
    </svg>
);

export default Cardano;
